import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import '../assets/css/Custom.css';

const CustomPrevArrow = ({ onClick }) => (
    <div className="custom-arrow custom-prev" onClick={onClick}>
        <FaChevronLeft />
    </div>
);

const CustomNextArrow = ({ onClick }) => (
    <div className="custom-arrow custom-next" onClick={onClick}>
        <FaChevronRight />
    </div>
);

const CustomCarousel = ({ slideData }) => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        centerMode: true,
        centerPadding: "0px",
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <div className="custom-slider-container">
            <Slider {...settings}>
                {slideData?.map((slide, index) => (
                    <div key={index} className="custom-slide">
                        <div className="testimonial-card">
                            <div className="stars">
                                {[...Array(5)].map((_, i) => (
                                    <span key={i} style={{ color: i < slide.rating ? '#ffc107' : '#e4e5e9' }}>★</span>
                                ))}
                            </div>
                            <p className="testimonial-text">{slide.remarks}</p>
                            <div className="testimonial-footer">
                                <img src={slide?.avatarImage} alt={slide.name} className="avatar" />
                                <div>
                                    <h3 className="testimonial-name">{slide.name}</h3>
                                    <p className="testimonial-role">{slide.designation}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default CustomCarousel;
